module.exports = __webpack_public_path__ + "fonts/Inter-Medium-slnt=0.5ff1f2a9.ttf";